import { ApiError } from './http';

export interface ApiEnvelope<T> {
  success: boolean;
  message?: string;
  error?: string;
  data?: T;
}

/** Desenvuelve el envelope `{success,message,error,data}` del backend GetPay93. */
export function unwrap<T>(env: ApiEnvelope<T>): T {
  if (!env || env.success === false) {
    const msg = env?.error ?? env?.message ?? 'La solicitud falló';
    throw new ApiError(0, msg, env);
  }
  return env.data as T;
}
